import React from 'react';
import { Text } from '@chakra-ui/react';

import { useMenu } from '../contexts/menu-with-quantities-ctx';
import { discountToNumber } from '../utils/discount';

function Resume() {
  const { menu } = useMenu();
  const combos = menu.combos.filter((c) => c.quantity !== 0);
  const products = menu.products.filter((p) => p.quantity !== 0);

  return (
    <>
      <br />
      {combos.length !== 0 && (
        <>
          <br /> <Text>Menù</Text>
        </>
      )}
      {combos.map((c, index) => (
        <li key={index}>
          {c.quantity} - {c.title}
        </li>
      ))}
      <br />
      {products.length !== 0 && <Text fontSize='xl' fontWeight='bold'>Prodotti</Text>}
      {products.map((p, index) => {
        const freeItems = discountToNumber(p)
        const freeItemsText = freeItems ? `+ ${freeItems}` : ''
        return (
          <li key={index}>
            {p.quantity} {freeItemsText} - {p.title}
          </li>
        );
      })}
    </>
  );
}

export default Resume;
